import { IonItem, IonLabel, IonToggle } from '@ionic/react'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import './Toggle.component.css'

export interface IToggle {
  leftLabel?: string
  rightLabel: string
  dataTestId: string
  onChangeAction: (...args: any[]) => any
  isChecked: boolean
  className?: string
  toogleClassName?: string
  isAirTemp?: boolean
}

const Toggle: React.FC<IToggle> = (props: IToggle) => {
  const { leftLabel, rightLabel, dataTestId, onChangeAction, isChecked, className, toogleClassName, isAirTemp } = props
  const [checked, setChecked] = useState(isChecked)
  const dispatch = useDispatch()

  return (
    <IonItem lines='none' className={className}>
      {leftLabel && (
        <IonLabel
          color={isAirTemp && !isChecked ? 'primary' : 'medium'}
          className={isAirTemp ? 'airTemp-toggle toggle-prefix-width' : 'toggle-prefix-width'}>
          {leftLabel}
        </IonLabel>
      )}
      <IonToggle
        data-testid={dataTestId}
        checked={checked}
        onIonChange={(e) => {
          setChecked(e.detail.checked)
          dispatch(onChangeAction(e.detail.checked))
        }}
        color='zoll-blue-secondary'
        className={toogleClassName}
      />
      <IonLabel
        color={isAirTemp && isChecked ? 'primary' : 'medium'}
        className={isAirTemp ? 'airTemp-toggle toggle-postfix-padding' : 'toggle-postfix-padding'}>
        {rightLabel}
      </IonLabel>
    </IonItem>
  )
}

export default Toggle
